export enum TapwellGroupWebsite {
    TapwellB2C = "TapwellB2C",
    TapwellB2B = "TapwellB2B",
    BricmateB2C = "BricmateB2C",
    HavenB2B = "HavenB2B",
    BricmateB2B = "BricmateB2B",
}
